import Styles from "./AppHeader.module.scss"
import {useAtomValue} from "jotai";
import {currentStepIdAtom} from "./stepper/currentStepAtom.ts";
import {combineStyles} from "../util/combineStyles.ts";

const USAGE_GUIDE_URL = "https://docs.maia.ai/docs/guides/maud"

export function AppHeader() {
    const currentStepId = useAtomValue(currentStepIdAtom)
    const isHero = currentStepId === 0

    return <header className={combineStyles(Styles.Header, isHero ? Styles.HeaderHero : undefined)}>
        <div className={Styles.Inner}>
            <h1 className={combineStyles(Styles.Title, isHero ? Styles.TitleHero : undefined)}>
                Matillion ETL Upgrade Analysis Tool
            </h1>
            <a
                className={Styles.GuideLink}
                href={USAGE_GUIDE_URL}
                target="_blank"
                rel="noopener noreferrer"
            >
                📖 Read the usage guide ↗
            </a>
        </div>
    </header>
}
